import React, { ReactNode } from "react";
import "./tabs.scss";
import { GradientWrapper } from "../gradientWrapper/gradientWrapper";

interface Tab {
  key: string;
  label: string;
  component: ReactNode;
}

interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (key: string) => void;
}

const Tabs: React.FC<TabsProps> = ({ tabs, activeTab, onTabChange }) => (
  <div className="custom-tabs" role="tablist">
    <div className="tab-header">
      {tabs.map((tab) => {
        const isSelected = activeTab === tab.key;
        return (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={isSelected}
            aria-current={isSelected}
            className={`tab-btn ${isSelected ? "active" : ""}`}
            onClick={() => onTabChange(tab.key)}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
    <GradientWrapper disableForDesktop display>
      <div className="tab-content">
        {tabs.find((tab) => tab.key === activeTab)?.component}
      </div>
    </GradientWrapper>
  </div>
);
export default Tabs;
